module.exports = __webpack_public_path__ + "img/117.f5c86ccc.png";